import { Button, Card } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FormData from "./WareHouseForm";
import usePermissions from "../../../hooks/permissions";
import useAuth from "../../../hooks/useAuth";
import { showWarning } from "../../../helpers/toast";
import { SideBarIds } from "../../../utils/constants";

const WareHouseForm = () => {
  const user = useAuth();
  const navigate = useNavigate();
  const permissions = usePermissions();

  const url = window.location.pathname;
  const path = url.includes("add");

  useEffect(() => {
    if (user?.role !== 1) {
      if (permissions) {
        let idx = -1;
        idx = permissions?.findIndex(
          (ele) => ele?.module?.id === SideBarIds.warehouse
        );
        if (idx > -1) {
          if (
            (!permissions[idx]?.is_add && path) ||
            (!permissions[idx]?.is_edit && !path)
          ) {
            showWarning("You are not authorized to access this page");
            navigate(-1);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions, user]);

  return (
    <div className="module-container">
      <Card>
        <div className="detail-module-card">
          <h2>{!path ? "Edit " : "Add "}WareHouse</h2>
          <Button
            className="back-btn-container"
            type="primary"
            // htmlType="submit"
            onClick={() => {
              navigate("/manage-warehouse", { replace: true });
            }}
          >
            Back
          </Button>
        </div>
        <FormData path={!path} />
      </Card>
    </div>
  );
};

export default WareHouseForm;
